import { ErrorPacket, Next, Pipe } from '../types';
import { ErrorConverterService } from '../../services/error-converter.service';
import { ErrorTrustedService } from '../../services/error-trusted.service';

export class TrustedErrorPipe implements Pipe<ErrorPacket, ErrorPacket> {
    public constructor(
        private readonly errorConverter: ErrorConverterService,
        private readonly errorTrustedService: ErrorTrustedService,
    ) {}

    public handle(packet: ErrorPacket, next: Next<ErrorPacket, ErrorPacket>): ErrorPacket {
        if (packet.result) return next(packet);

        const error: any = packet.data;

        if (!error || typeof error !== 'object' || !('isTrusted' in error)) {
            return next(packet);
        }

        this.errorTrustedService.isError.next(true);

        const scriptError: string = JSON.stringify(error, ['message', 'arguments', 'type', 'name']);

        return {
            ...packet,
            result: this.errorConverter.getAppErrorFromError(scriptError),
        };
    }
}
